(function(){
  // Keep a live set of product ids currently in the cart, used to hide recommendation cards for
  // products the shopper has already added (so "You may also like" behaves like "Frequently bought
  // together"). Refreshed on every cart change.
  function getCartIds(){
    return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var ids={}; (c.items||[]).forEach(function(it){ if(it.product_id!=null){ ids[it.product_id]=1; } }); window.__u4CartIds=ids; return ids;
    }).catch(function(){ return window.__u4CartIds||{}; });
  }
  function filterAll(){ document.querySelectorAll('u4-cart-recs').forEach(function(el){ if(el.filterCart){ el.filterCart(); } }); }

  if(!window.__u4CartRecs){
    window.__u4CartRecs=true;
    window.__u4RecsCache=window.__u4RecsCache||{};
    class U4CartRecs extends HTMLElement{
      connectedCallback(){
        var self=this;
        window.__u4RecsCache=window.__u4RecsCache||{};
        this._mo=new MutationObserver(function(){
          if(self.querySelector('.u4-upsell-card'))return;
          var u=self.getAttribute('data-url');
          if(u&&window.__u4RecsCache[u]!==undefined){ self.render(window.__u4RecsCache[u]); }
          else { self.load(); }
        });
        this._mo.observe(this,{childList:true});
        var url=this.getAttribute('data-url');
        if(url&&window.__u4RecsCache[url]!==undefined){ this.render(window.__u4RecsCache[url]); return; }
        this._io=new IntersectionObserver(function(es,o){
          if(es[0]&&es[0].isIntersecting){ o.disconnect(); self.load(); }
        },{rootMargin:'0px 0px 600px 0px'});
        this._io.observe(this);
        setTimeout(function(){ if(!self.querySelector('.u4-upsell-card')){ self.load(); } }, 700);
      }
      disconnectedCallback(){ if(this._io){ this._io.disconnect(); } if(this._mo){ this._mo.disconnect(); } }
      // hide recommendation cards whose product is already in the cart; hide the whole section if none remain
      filterCart(){
        var ids=window.__u4CartIds; if(!ids){ return; }
        var cards=this.querySelectorAll('.u4-upsell-card'); if(!cards.length){ return; }
        var visible=0;
        cards.forEach(function(card){
          var pid=card.getAttribute('data-product-id');
          if(pid&&ids[pid]){ card.style.display='none'; }
          else { card.style.display=''; visible++; }
        });
        var sec=this.closest('.u4-upsell-section');
        if(sec){ sec.style.display = visible ? '' : 'none'; }
      }
      render(html){
        var self=this;
        var sec=this.closest('.u4-upsell-section');
        if(html&&html.indexOf('u4-upsell-card')!==-1){
          if(this.innerHTML!==html){ this.innerHTML=html; }
          if(window.__u4CartIds){ this.filterCart(); }           // instant pass with whatever we have
          getCartIds().then(function(){ self.filterCart(); });    // then re-filter with FRESH cart ids
        }
        else if(sec){ sec.remove(); }
      }
      async load(){
        var url=this.getAttribute('data-url'); if(!url){return;}
        if(this._loading){return;} this._loading=true;
        var sec=this.closest('.u4-upsell-section');
        try{
          var res=await fetch(url,{headers:{'Accept':'text/html'}});
          if(!res.ok){ if(sec)sec.remove(); return; }
          var html=await res.text();
          window.__u4RecsCache[url]=html;
          this.render(html);
        }catch(e){ if(sec)sec.remove(); }
        finally{ this._loading=false; }
      }
    }
    if(!customElements.get('u4-cart-recs')){ customElements.define('u4-cart-recs',U4CartRecs); }

    // refresh the cart-product set and re-filter the recommendation sections on any cart change
    ['cart:refresh','cart:updated','cart:change'].forEach(function(ev){ document.addEventListener(ev,function(){ getCartIds().then(filterAll); }); });
    getCartIds().then(filterAll);

    // Native remove / qty buttons morph the cart drawer but DON'T fire those events — so a removed
    // product's card would stay hidden until reload. Watch the drawer for any change, refresh the
    // cart-product set, and re-filter so the card reappears immediately when the item is removed.
    (function attachCartWatch(){
      function watch(){
        var host=document.querySelector('cart-drawer-component')||document.querySelector('.cart-drawer');
        if(host&&!host.__u4recsObs){
          host.__u4recsObs=true;
          var t=null;
          new MutationObserver(function(){ clearTimeout(t); t=setTimeout(function(){ getCartIds().then(filterAll); },150); }).observe(host,{childList:true,subtree:true});
        }
      }
      if(document.readyState!=='loading'){ watch(); } else { document.addEventListener('DOMContentLoaded',watch); }
      setTimeout(watch,1200);
    })();
  }
  if(!window.__u4UpsellAdd){
    window.__u4UpsellAdd=true;
    document.addEventListener('submit',async function(e){
      var form=e.target&&e.target.closest?e.target.closest('.u4-upsell-add-form'):null;
      if(!form)return;
      e.preventDefault();
      var btn=form.querySelector('button[type=submit]'); if(btn)btn.disabled=true;
      try{
        await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        await getCartIds();            // refresh cart ids BEFORE the drawer morph re-renders the recs
        var cc=document.querySelector('cart-items-component[data-section-id]');
        var sid=cc?cc.getAttribute('data-section-id'):null;
        var done=false;
        if(sid){
          try{
            var r=await fetch(location.pathname+'?sections='+encodeURIComponent(sid));
            var data=await r.json();
            if(data&&data[sid]){
              var tmp=document.createElement('div'); tmp.innerHTML=data[sid];
              var fresh=tmp.querySelector('.cart-drawer__inner');
              var cur=document.querySelector('.cart-drawer__inner');
              if(fresh&&cur){ cur.innerHTML=fresh.innerHTML; done=true; }
            }
          }catch(err){}
        }
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        filterAll();
        if(!done){ location.reload(); }
      }catch(err){ if(btn)btn.disabled=false; }
    });
  }
})();
